import type { ReactNode } from "react";

// Card from the admin redesign: rounded, soft border/shadow, an optional title
// row with actions, then full-width content. Shared by the redesigned list pages.
export function Panel({ title, actions, children, className = "" }: {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={`rounded-2xl border border-gray-200 bg-white shadow-sm dark:border-[#1E2E4D] dark:bg-panel ${className}`}>
      {(title || actions) && (
        <header className="flex flex-wrap items-center justify-between gap-3 px-5 pb-3 pt-4">
          <h2 className="min-w-0 text-[15px] font-semibold text-gray-900 dark:text-slate-100">{title}</h2>
          {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
        </header>
      )}
      <div className="px-5 pb-5">{children}</div>
    </section>
  );
}
